import { mediaData } from '@/mocks/homeData';

export default function MediaSection() {
  const scrollTo = (id: string) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">精彩视频推荐</h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">编辑精选的优质综艺内容，高清画质流畅播放，每一部都值得细细品味</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {mediaData.map((item) => (
            <article key={item.id} className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer">
              <div className="relative w-full aspect-[16/10] bg-background-200 flex items-center justify-center overflow-hidden">
                <div className="absolute inset-0 bg-gradient-to-br from-secondary-200/60 via-accent-100/40 to-primary-100/30"></div>
                <div className="relative z-10 w-14 h-14 md:w-16 md:h-16 rounded-full bg-primary-500/90 flex items-center justify-center group-hover:bg-primary-600 transition-colors">
                  <i className="ri-play-fill text-background-50 text-2xl md:text-3xl ml-0.5"></i>
                </div>
                <div className="absolute bottom-2 right-3 z-10">
                  <span className="px-2 py-0.5 bg-black/60 text-background-50 text-xs rounded whitespace-nowrap">{item.duration}</span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-base font-bold text-foreground-900 mb-1.5 line-clamp-2">{item.title}</h3>
                <p className="text-foreground-600 text-xs leading-relaxed mb-3 line-clamp-2">{item.desc}</p>
                <div className="flex items-center gap-2 text-foreground-500 text-xs">
                  <i className="ri-eye-line"></i>
                  <span>{item.views} 次观看</span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}